import {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import ActionBar from "~/layout/ActionBar";
import {
	Loading, Icon, Button, Modal
} from "~/components";
import {
	apiError,
	handleRequest,
	strToTime
} from "~/utils";
import {
	salarySlipActions,
	salarySlipErrorSelector,
	salarySlipFilterSelector,
	salarySlipItemsSelector,
	salarySlipLoadingSelector,
	salarySlipPaginationSelector
} from "../salarySlipSlice";
import {
	SalarySlipTable,
	SalarySlipFormAddEdit,
	SalarySlipSearchBar
} from "../components";
import {
	salarySlipApi
} from "~/api";

function SalarySlip() {

	const dispatch  = useDispatch();

	const items     = useSelector(salarySlipItemsSelector);

	const loading   = useSelector(salarySlipLoadingSelector);

	const error     = useSelector(salarySlipErrorSelector);

	const pagination = useSelector(salarySlipPaginationSelector);

	const filter    = useSelector(salarySlipFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	//Model
	const [openModal, setOpenModal] = useState({
		addEdit     : false,
		delete      : false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	//Load data
	useEffect(() => {
		dispatch(salarySlipActions.fetchData({...filter}));
	}, [filter]);

	//Show Error
	if (error) {
		notification.error({message: 'Lỗi', description: error});
	}

	//Submit
	const handleSaveItem = async (data, isEdit) => {
		let messageAction = 'Thêm mới';
		if(isEdit)
		{
			if (!itemEdit?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin phiếu lương để cập nhật'});
				return;
			}
			data.id = itemEdit.id;
			messageAction = 'Cập nhật';
		}
		data.salaryMonth = strToTime(data.salaryMonth);
		data.paidDate = strToTime(data.paidDate);
		let [error, response] = (isEdit) ? await handleRequest(salarySlipApi.update(data)) : await handleRequest(salarySlipApi.add(data));
		let message = apiError(`${messageAction} phiếu lương thất bại`, error, response);
		if(!message)
		{
			notification.success({message: 'Thành công', description: `${messageAction} phiếu lương thành công`});
			if(!isEdit)
			{
				const added = Array.isArray(response.data) ? response.data : [response.data];
				added.forEach(item => dispatch(salarySlipActions.add(item)));
			}
			else {
				setItemEdit(response.data);
				dispatch(salarySlipActions.update(response.data));
			}
			handleModalClose('addEdit')
		}
	}

	//Delete
	const handleDelete = async () =>
	{
		if (!itemEdit?.id)
		{
			notification.error({message: 'Lỗi', description: 'Không có thông tin phiếu lương để xóa'});
			return;
		}
		let [error, response] = await handleRequest(salarySlipApi.delete(itemEdit.id));

		let message = apiError(`xóa phiếu lương thất bại`, error, response);

		if(!message)
		{
			notification.success({message: 'Thành công', description: `xóa phiếu lương thành công`});
			dispatch(salarySlipActions.delete(itemEdit.id));
			handleModalClose('delete')
		}
	}

	//Search
	const handlePaginationChange = (page) => {
		dispatch(salarySlipActions.setFilter({...filter, page }));
	}

	const handleFilterChange = (key, value) => {
		const newFilter = {
			...filter,
			[key]: value,
			page: 1
		};
		dispatch(salarySlipActions.setFilter(newFilter));
	};

	return (
			<Fragment>
				<ActionBar title={'Phiếu lương'}>
					<Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({});handleModalOpen('addEdit')}}>Thêm mới</Button>
					<Button outline small onClick={() => dispatch(salarySlipActions.fetchData({...filter}))} style={{fontSize:'20px'}}>{Icon.reload}</Button>
				</ActionBar>
				<div className="container">
					<div className="content">
						{loading && <Loading/>}
						{<SalarySlipSearchBar filter={filter} onChange={handleFilterChange} />}
						{items && <SalarySlipTable
							items={items}
							pagination={pagination}
							onPaginationChange={handlePaginationChange}
							setItemEdit={setItemEdit}
							openModal={handleModalOpen}
						/>}
					</div>
					{
						<Modal title="Phiếu lương" visible={openModal.addEdit} onCancel={() => {handleModalClose('addEdit')}}>
							<SalarySlipFormAddEdit item={itemEdit} onHandleSubmit={handleSaveItem} />
						</Modal>
					}
					{
						(itemEdit?.id) && <Modal title="Xóa phiếu lương" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
							<p>Bạn muốn xóa phiếu lương <b>PL{itemEdit?.id}</b>?</p>
							<br />
							<div className="d-flex justify-content-end gap pd-1 modal-bottom">
								<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
								<Button primary leftIcon={Icon.delete} onClick={handleDelete}> Xóa </Button>
							</div>
						</Modal>
					}
				</div>
			</Fragment>
	)
}
export default SalarySlip;
